import "./Header.scss";

const Footer = () => {
    return (
        <>
            <div className="footer-top">
                Website belongs to
                Department of School Education & Literacy,
                Ministry of Education.
                Designed, Developed and Hosted by
                National Informatics Centre ( NIC )
            </div>
        </>
    )
}


export default Footer